import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import SingleTestimonialThree from '../../components/Testimonial/SingleTestimonialThree';
import DataState from '../../components/DataState';
import { useCollections } from '../../lib/api/collections';
import { initialsAvatars } from '../../data/images';



const TestimonialMain = () => {
  const content = useCollections('testimonials');
  if (content.loading || content.error) return <DataState state={content} />;
  const { testimonials } = content;

  return (
    <main>
      <Breadcrumb title="Student Voices" subTitle="Student Voices" />

      <div className="it-testimonial-area ed-testimonial-style-2 pt-120 pb-120 fix p-relative">
        <div className="container">
          <div className="row">
            {testimonials.map((t, i) => (
              <div key={t.fullName} className="col-xl-6 col-lg-6 mb-30">
                <SingleTestimonialThree
                  description={`“${t.quoteShort}”`}
                  authorAvatar={initialsAvatars[i % initialsAvatars.length]}
                  authorName={t.displayName}
                  designation={t.role}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};
export default TestimonialMain;
